export default __webpack_public_path__ + "static/media/laserCutting.44a1d665.jpeg";